import React, { useState, useEffect } from "react";
import {
  FaEnvelope,
  FaPhoneSquare,
  FaUser,
  FaExpand,
  FaCompress,
} from "react-icons/fa"; // Import FontAwesome icons
import {
  Button,
  Dropdown,
  Form,
  Card,
  Row,
  Col,
  Pagination,
} from "react-bootstrap";
import ForwardPrayerModal from "./ForwardPrayerModal"; // Import the modal
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import * as XLSX from "xlsx"; // Import XLSX for exporting data
import { useAuth } from "../../auth/AuthContext";
import {
  fetchPrayerRequests,
  updatePrayerReqStatus,
} from "../../services/PrayerServices";
import {
  PRAYER_REQUEST_CATEGORIES,
  PRAYER_REQUEST_STATUSES,
} from "../common/Constants";
const ListPrayerRequestSummaryTilePage = () => {
  const { user } = useAuth();
  const [prayerRequests, setPrayerRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    status: "Sent to Marian",
    category: "Prayer",
    actionedBy: "",
  });

  // State to handle the expanded message and review fields

  const [expandedCardId, setExpandedCardId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(prayerRequests.length / itemsPerPage);

  const toggleCardExpansion = (id) => {
    const prayer = prayerRequests.find((prayer) => prayer.id === id);
    if (expandedCardId === id && prayer.replyMessage?.trim().length > 0) {
      // Trigger email logic here
      console.log(`Triggering email for prayer request ${id}`);
      // Add your email sending logic here
    }
    setExpandedCardId((prevId) => (prevId === id ? null : id));

  };

  const fetchPrayerRequestsData = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchPrayerRequests(filters);
      setPrayerRequests(data);
    } catch (err) {
      console.error("Error fetching prayer requests", err);
      setError("Error fetching prayer requests");
    } finally {
      setLoading(false);
    }
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const [showModal, setShowModal] = useState(false);
  const [selectedPrayer, setSelectedPrayer] = useState(null);

  const handleForward = (prayer, email,message) => {
    console.log(`Forwarding prayer request ${prayer.id} to ${email}`);
    prayer.remark = prayer.remark+" Forwarded to " + email + " with message: " + message;
    handleChangeStatus(prayer.id, "Forwarded", email);
  };
  const handleChangeStatus = async (id, newStatus, email) => {
    try {
      if (!user || !user.userID) {
        alert("User is not authenticated.");
        return;
      }

      let actionedBy = user.userID || "Admin";
      const prayer = prayerRequests.find((prayer) => prayer.id === id);
      console.log("Updating prayer request status", {
        id,
        newStatus,
        actionedBy,
      });

      if (newStatus === "Forwarded" && !email) {
        await updatePrayerReqStatus(prayer, prayer.status, actionedBy);
        setPrayerRequests((prevRequests) =>
          prevRequests.map((prayer) =>
            prayer.id === id ? { ...prayer, actionedBy } : prayer
          )
        );
        //no status change just save remarks and email
      } else {
        // Call API to update the status
        await updatePrayerReqStatus(prayer, newStatus, actionedBy);
        setPrayerRequests((prevRequests) =>
          prevRequests.map((prayer) =>
            prayer.id === id
              ? { ...prayer, status: newStatus, actionedBy }
              : prayer
          )
        );
      }
      // Now update state only if API call is successful
    } catch (err) {
      console.error("Error updating prayer request status", err);
      alert("Error updating prayer request status");
    }
  };

  const handleExportToXLS = () => {
    const ws = XLSX.utils.json_to_sheet(prayerRequests);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Prayer Requests");
    XLSX.writeFile(wb, "PrayerRequests.xlsx");
  };

  const handleReviewChange = (id, e) => {
    const { name, value } = e.target;

    setPrayerRequests((prevRequests) =>
      prevRequests.map((prayer) =>
        prayer.id === id ? { ...prayer, [name]: value } : prayer
      )
    );
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const paginatedPrayerRequests = prayerRequests.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    fetchPrayerRequestsData(); // Fetch data only on screen load
  }, []);

  useEffect(() => {
    if (expandedCardId) {
      document.getElementById(`prayer-${expandedCardId}`)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [expandedCardId]);

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>
      {/* Title Section */}
      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">Prayer Blessing</h1>
          </div>
        </div>
      </div>

      <div className="container mt-3 mb-3">
        <div className="row g-2 d-flex justify-content-center mb-2">
          <div className="col-sm-6 col-md-3">
            <Form.Control
              type="date"
              name="fromDate"
              value={filters.fromDate}
              onChange={handleFilterChange}
            />
          </div>
          <div className="col-sm-6 col-md-3">
            <Form.Control
              type="date"
              name="toDate"
              value={filters.toDate}
              onChange={handleFilterChange}
            />
          </div>
          <div className="col-sm-6 col-md-3">
            <Form.Select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              {PRAYER_REQUEST_STATUSES.map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="col-sm-6 col-md-3 text-center">
            <Button
              className="btn btn-primary btn-sm me-2 btn-block"
              onClick={fetchPrayerRequestsData}
            >
              <i className="fas fa-list"></i> List
            </Button>
            <Button
              onClick={handleExportToXLS}
              className="btn btn-success btn-sm btn-block"
              disabled={prayerRequests.length === 0}
            >
              <i className="fas fa-file-excel"></i> Excel
            </Button>
          </div>
        </div>

        {/* Data Loading */}
        {loading && <div className="alert alert-info">Loading...</div>}
        {error && <div className="alert alert-danger">{error}</div>}
        {/* Prayer Requests List with Cards */}
        {!loading && paginatedPrayerRequests.length > 0 && (
          <>
            <Row className="g-3">
              {paginatedPrayerRequests.map((prayer) => (
                <Col
                  key={prayer.id}
                  xs={6}
                  sm={6}
                  md={4}
                  className={
                    expandedCardId === prayer.id ? "expanded-card" : ""
                  }
                  ref={(el) => {
                    if (expandedCardId === prayer.id && el) {
                      el.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                  }}
                >
                  <Card id={`prayer-${prayer.id}`} className="shadow-sm">
                    <Card.Body>
                      {/* Title Section - Always Visible */}
                      <Card.Title className="d-flex justify-content-between align-items-center">
                        <span>
                          <FaUser className="me-2" /> {prayer.firstName}{" "}
                          {prayer.lastName}
                        </span>
                        <Button
                          variant="link"
                          className="position-absolute top-0 end-0 m-1 btn-sm btn-info"
                          onClick={() => toggleCardExpansion(prayer.id)}
                        >
                          {expandedCardId === prayer.id ? (
                            <FaCompress size={20} />
                          ) : (
                            <FaExpand size={20} />
                          )}
                        </Button>
                      </Card.Title>

                      {expandedCardId === prayer.id && (
                        <Card.Subtitle className="mb-2 text-muted">
                          <a href={`mailto:${prayer.email}`}>
                            <FaEnvelope className="me-0" /> {prayer.email}
                          </a>
                          <a href={`tel:${prayer.phone}`} className="ms-2">
                            <FaPhoneSquare className="me-0" /> {prayer.phone}
                          </a>
                        </Card.Subtitle>
                      )}
                      {/* Prayer Summary & Message */}
                      <Card.Text className="text-break">
                        <strong>Summary:</strong>{" "}
                        {prayer.summary || "No summary provided."}
                      </Card.Text>
                      {/* Expanded View - Shows Details When Open */}
                      {expandedCardId === prayer.id && (
                        <>
                          <Card.Text className="text-break">
                            <strong>Prayer Request:</strong> {prayer.message}
                          </Card.Text>

                          <Card.Text className="text-break">
                            <strong>Prayer Reply:</strong>{" "}
                            {prayer.replyMessage || "No reply yet."}
                          </Card.Text>

                          {/* Marian's Response Field */}
                          <Form.Group className="mb-2">
                            <Form.Label>
                              <strong>Response from Marian:</strong>
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={4}
                              name="messageFromMarian"
                              placeholder="Enter prayer message to the requestor..."
                              value={prayer.messageFromMarian || ""}
                              onChange={(e) => handleReviewChange(prayer.id, e)}
                            />
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <Form.Label>
                              <strong>Remarks:</strong>
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={1}
                              name="remarks"
                              placeholder="Enter Remarks"
                              value={prayer.remarks || ""}
                              onChange={(e) => handleReviewChange(prayer.id, e)}
                            />
                          </Form.Group>
                        </>
                      )}

                      {/* Buttons Section */}
                      <div className="d-flex justify-content-between mt-2">
                        <Button
                          className="btn-secondary btn-sm"
                          onClick={() => {
                            setSelectedPrayer(prayer);
                            setShowModal(true);
                          }}
                        >
                          Forward
                        </Button>
                        <Button
                          className="btn-success btn-sm"
                          onClick={() =>
                            handleChangeStatus(prayer.id, "Blessed")
                          }
                        >
                          + Bless +
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            <div className="d-flex justify-content-end mt-3">
              <Button
                className="btn btn-success"
                onClick={async () => {
                  const actionedRequests = prayerRequests.filter(
                    (prayer) =>
                      prayer.status === "Sent To Marian" &&
                      prayer.summary?.trim().length > 0
                  );

                  for (const prayer of actionedRequests) {
                    // or Email to Admin
                    await handleChangeStatus(prayer.id, "Blessed");
                  }
                }}
                disabled={prayerRequests.length <= 0}
              >
                Bless All
              </Button>
            </div>
          </>
        )}
        {/* Pagination */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <Pagination>
              {Array.from({ length: totalPages }, (_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={currentPage === index + 1}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
            </Pagination>
          </div>
        )}

        {/* No Results Message */}
        {!loading && prayerRequests.length === 0 && (
          <p>No prayer requests found for the selected filters.</p>
        )}
      </div>
      <FooterPanel />
      <ForwardPrayerModal
        title={`${selectedPrayer?.firstName} ${selectedPrayer?.lastName}`}
        show={showModal}
        handleForward={(email,message) => handleForward(selectedPrayer, email,message)}
        handleClose={() => setShowModal(false)}
      />
    </React.Fragment>
  );
};
export default ListPrayerRequestSummaryTilePage;
